import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import ShowKindergarten from "src/components/panel/kindergarten/show_kindergarten/ShowKindergarten";

const ShowKindergartenView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("kindergarten_view")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb title={t("kindergarten_title")} />
        <ShowKindergarten />
      </Sidebar>
    </>
  );
};

export default ShowKindergartenView;
